import { useState } from "react";
import EmployeeSelect from "./EmployeeSelect";
import { findEmployeeById, formatEmployeeLabel } from "./employeeUtils";
import { useEmployees } from "../../hooks/useEmployees";

/** Pick multiple employees (optional filter — empty means all). */
export default function EmployeeMultiSelect({
  value = [],
  onChange,
  label = "Employees",
  hint = "Leave empty to include all employees",
  className = "",
}) {
  const { employees } = useEmployees();
  const [pick, setPick] = useState("");

  const add = () => {
    if (!pick || value.includes(pick)) return;
    onChange?.([...value, pick]);
    setPick("");
  };

  const remove = (id) => {
    onChange?.(value.filter((x) => x !== id));
  };

  return (
    <div className={className}>
      {label && <label className="block text-sm font-medium text-slate-700 mb-1">{label}</label>}
      <div className="flex gap-2">
        <div className="flex-1">
          <EmployeeSelect
            value={pick}
            onChange={setPick}
            allowEmpty
            emptyLabel="Add employee…"
            hideLabel
          />
        </div>
        <button
          type="button"
          onClick={add}
          disabled={!pick}
          className="px-3 py-2 rounded-lg bg-slate-100 text-slate-700 text-sm hover:bg-slate-200 disabled:opacity-40"
        >
          Add
        </button>
      </div>
      {value.length > 0 ? (
        <div className="flex flex-wrap gap-2 mt-2">
          {value.map((id) => {
            const emp = findEmployeeById(employees, id);
            return (
              <span
                key={id}
                className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-teal-50 text-teal-800 text-xs border border-teal-200"
              >
                {formatEmployeeLabel(emp) || id}
                <button
                  type="button"
                  onClick={() => remove(id)}
                  className="text-teal-600 hover:text-teal-900 font-bold leading-none"
                  aria-label="Remove"
                >
                  ×
                </button>
              </span>
            );
          })}
          <button
            type="button"
            onClick={() => onChange?.([])}
            className="text-xs text-slate-500 underline"
          >
            Clear all
          </button>
        </div>
      ) : (
        <p className="text-xs text-slate-400 mt-1">{hint}</p>
      )}
    </div>
  );
}
